import React, { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

import GoogleLogin from 'react-google-login';
import { useLocation } from "react-router-dom";

const theme = createTheme();



export const SignIn = () => {

    const cookies = new Cookies(); 
    const cookieId = cookies.get('id');

    const search = useLocation().search;
    const param1 = new URLSearchParams(search).get("p") || './admin';
    // console.log({ result: param1 });

    const isValidCibnorUser = (user) => {
        console.log(user);
        const email = user.email;
        const domain = email.substring( email.lastIndexOf('@')+1 );
        // console.log(email, domain);

        if (domain !== "cibnor.mx" && domain !== "pg.cibnor.mx") {
            return false
        }

        cookies.set('id', user.googleId, {path: '/'})
        cookies.set('correo', user.email, {path: '/'})
        cookies.set('nombre', user.givenName, {path: '/'})
        cookies.set('apellido', user.familyName, {path: '/'})
        cookies.set('imagen', user.imageUrl, {path: '/'})

        return true;
    }

    const respuestaGoogle = (respuesta) => {
        console.log(respuesta);

        if (respuesta.profileObj !== null) {

            const result = isValidCibnorUser(respuesta.profileObj);

            if (result) {
                window.location.replace(`./${ param1 }`);
                // window.location.replace('/registro/en-linea/admin');
            } else {
                Swal.fire("El usuario no es valido.", `Utiliza tu cuenta del CIBNOR para acceder.`, "warning");
            }
        }
    }


    useEffect(() => {

        const isSessionActive = () => {

            // const param1 = GetParamById("p");

            document.title = "Iniciar sesión";

            // console.log(cookieId);
            if ( cookieId ) {
                // En pruebas en el login es necesario intercambiar estos dos comandos
                //   window.location.replace('/registro/en-linea/admin');
              window.location.replace(`./${ param1 }`);
            }
        };

        isSessionActive();

    }, [ cookieId, param1 ])
    

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Grid item xs={12} >
                        <Typography variant="h4" align="center">Sistema de Consulta de Registros</Typography>
                    </Grid>
                    <Avatar sx={{ m: 4, bgcolor: "primary.main" }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <div>
                        <GoogleLogin
                            clientId="151222650271-caqmfsit0apqemq0j87j785v8frkdu64.apps.googleusercontent.com"
                            buttonText="Iniciar sesión"
                            onSuccess={ respuestaGoogle }
                            onFailure={ respuestaGoogle }
                            cookiePolicy={ 'single_host_origin' }
                            scope="profile"
                        />
                    </div>
                </Box>
            </Container>
        </ThemeProvider>
    );
};
